import Seo from "@/lib/Seo";
import { PageHead } from "@/pages/About";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

export default function Team() {
  const principles = [
    ["نفهم ونحلل السياق", "نبدأ بفهم الواقع وأصحاب المصلحة والاحتياج الحقيقي."],
    ["نصمّم مع شركائنا", "نؤمن أن الحل الأقوى يُبنى بالشراكة، لا بمعزل عن المنظمة."],
    ["نمكّن ونمارس الاستدامة", "ننقل المعرفة والأدوات لتبقى القدرة داخل المنظمة."],
  ];
  return <>
    <Seo path="/team" title="فريق سياق" description="فريق سياق الذي يجمع الخبرة الاستشارية بفهم عميق للقطاع المجتمعي." />
    <PageHead eyebrow="فريق سياق" title="خبرات متنوّعة، يجمعها سياق واحد" subtitle="نعمل كفريق متعدد التخصصات على فهم التحديات وتصميم الحلول وتمكين المنظمات من صناعة أثرها" />
    <section className="bg-paper py-20"><div className="mx-auto max-w-[1400px] px-6 sm:px-10 grid lg:grid-cols-3 gap-6">
      {principles.map(([title,text],i)=><Reveal key={title} delay={i*.06}><article className="bg-white border border-navy/10 p-8 min-h-56"><span className="text-coral text-sm">٠{i+1}</span><h2 className="font-display text-navy text-2xl mt-5">{title}</h2><p className="text-blue leading-relaxed mt-4">{text}</p></article></Reveal>)}
    </div><div className="text-center mt-12 flex flex-wrap justify-center gap-3"><Link to="/careers?type=join" data-testid="team-join-cta" className="inline-flex bg-navy text-white px-7 py-4">انضم إلى فريق سياق</Link><Link to="/careers?type=coop" data-testid="team-coop-cta" className="inline-flex border border-navy text-navy px-7 py-4 hover:bg-navy hover:text-white transition-colors">التدريب التعاوني</Link></div></section>
  </>;
}
